import { Church, Briefcase } from "lucide-react";

const partners = [
  {
    icon: Church,
    name: "Zion Full Gospel World Ministries",
    role: "Spiritual Nourishment & Faith Partnership",
    desc: "Walking alongside families with prayer, community, and the rooted hope that anchors our work.",
  },
  {
    icon: Briefcase,
    name: "1st Touch Enterprise Holdings, LLC",
    role: "Clinical, Operational & Supportive Care",
    desc: "Our strategic partner providing operational depth and clinical, supportive care services.",
  },
];

export default function Partners() {
  return (
    <section id="partners" data-testid="partners-section" className="bg-[#F4F1EB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="max-w-2xl mb-14">
          <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-4">
            Strategic Partners
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#2C2A29] leading-[1.05] tracking-tight">
            A compassionate ecosystem.
          </h2>
          <p className="mt-5 text-[#5C5856] text-lg">
            Faith, service, and skilled care — woven together to meet families wherever they stand.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {partners.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.name}
                data-testid={`partner-${p.name.split(" ")[0].toLowerCase()}`}
                className="rounded-3xl bg-[#FAF8F5] border border-[#E2DCD0] p-10 hover:shadow-md transition-all"
              >
                <div className="w-12 h-12 rounded-full bg-[#2A4747] text-[#F4F1EB] flex items-center justify-center mb-6">
                  <Icon size={20} strokeWidth={2} />
                </div>
                <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-2">
                  {p.role}
                </div>
                <h3 className="font-serif text-2xl sm:text-3xl text-[#2C2A29] leading-snug">{p.name}</h3>
                <p className="mt-4 text-[#5C5856] leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
